import { Route, Switch } from "react-router-dom";

import FabioTestPage from "../../workspace/fc/fabio-test";

export function FabioCarmoRoutes() {
  return (
    <Switch>
      <Route path="/fc/fabio-test" component={FabioTestPage} />
    </Switch>
  );
}

export const slug = "fc";
